export class DomandaRadio {
  value: string;
  key: number;
  label: string;
  required: boolean;
  order: number;
  controlType = 'radio';
  options: { key: number; value: string }[] = [];

  constructor(
    options: {
      value?: string;
      key?: number;
      label?: string;
      required?: boolean;
      order?: number;
      options?: { key: number; value: string }[];
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || -1;
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.options = options['options'] || [];
  }
}
